import SignupNoteCaption from '@spa/components/pages/auth/signup/with-sms/components/note/default/SignupNoteCaption.vue'
import Vue from 'vue'

const base = (name: string, text: string) => Vue.extend({
  name,
  components: { SignupNoteCaption },
  template: `<signup-note-caption>${text}</signup-note-caption>`,
})

export const forSingup = base('SignupNote', `簡単なお手続きで会員登録いただけます。`)

export const forCartSignup = base('CartSignupNote', `簡単なお手続きで会員登録いただけます。`)

export const forPlanApplySignup = base('PlanApplyNote', `簡単なお手続きでサブスクリプションをご契約いただけます。`)

export const captionsForSignupContext = {
  forSingup,
  forCartSignup,
  forPlanApplySignup,
}
